/**
 * Landing page for a partner's link: /partner/$slug/properties/$propertyId/offer?t=<token>
 *
 * The `t` token is a long-lived credential, so it is held in memory for this
 * page and removed from the address bar at once (replacing the history entry)
 * before it can be bookmarked, shared or captured. Analytics also scrubs it
 * from captured URLs (common/analytics/urlScrub.ts).
 */

import { useEffect, useState } from 'react'
import { PartnerPropertyPage } from '@/features/partner-links/components/PartnerPropertyPage/PartnerPropertyPage'
import { validatePartnerLinkSearch } from '@/features/partner-links/utils/partnerLinkSearch'

export const Route = createFileRoute({
  validateSearch: validatePartnerLinkSearch,
  component: PartnerLinkRoute,
})

export function PartnerLinkRoute() {
  const { slug, propertyId } = Route.useParams()
  const { t } = Route.useSearch()
  const navigate = Route.useNavigate()
  // Captured on first render only; the address bar loses it right after.
  const [token] = useState(() => t ?? '')

  useEffect(() => {
    if (t !== undefined) {
      navigate({ search: {}, replace: true }).catch(() => {
        // The router could not navigate; strip the token from the address bar directly.
        window.history.replaceState(window.history.state, '', window.location.pathname)
      })
    }
  }, [t, navigate])

  return <PartnerPropertyPage token={token} slug={slug} propertyId={propertyId} />
}
